import { toast, type ExternalToast } from 'sonner';
import type { ReactNode } from 'react';

export enum TOAST_TYPES {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
  loading = 'loading',
}

export interface InformUserProps {
  message: ReactNode;
  title: string;
  toastId?: string;
  type: TOAST_TYPES;
  description?: ReactNode;
  props?: ExternalToast;
}

export const informUser = ({ message, title, toastId, type, props = {} }: InformUserProps) => {
  const options: ExternalToast = {
    description: message,
    duration: 3000,
    id: toastId,
    ...props,
  };
  switch (type) {
    case TOAST_TYPES.error:   toast.error(title, options); break;
    case TOAST_TYPES.info:    toast.info(title, options); break;
    case TOAST_TYPES.loading: toast.loading(title, options); break;
    case TOAST_TYPES.success: toast.success(title, options); break;
    case TOAST_TYPES.warning: toast.warning(title, options); break;
  }
};
